import React from 'react';
import { Plug, Zap } from 'lucide-react';
import { PLUG_DATA, getCountryData } from '@/data/essentials';

export default function PlugCard({ countryCode, countryName }) {
  const d = getCountryData(PLUG_DATA, countryCode);
  return (
    <div className="puvio-card p-5" data-testid="plug-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-mint-deep)]">Power & Plugs</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium">{countryName || 'Local standard'}</p>
        </div>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: '#FFEAD0' }}>
          <Plug className="w-6 h-6 text-[#B85F31]" />
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {d.types.map((t) => (
          <span key={t} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-2xl bg-[var(--puvio-bg-soft)] border border-[var(--puvio-border)] text-sm font-extrabold text-[#0F1A13]" data-testid={`plug-type-${t}`}>
            Type {t}
          </span>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-2 text-sm font-bold text-[#0F1A13]">
        <Zap className="w-4 h-4 text-[var(--puvio-sun)]" />
        <span data-testid="plug-voltage">{d.voltage} V</span>
        <span className="text-[var(--puvio-text-3)] font-medium">·</span>
        <span className="font-medium text-[var(--puvio-text-2)]" data-testid="plug-frequency">{d.frequency} Hz</span>
      </div>
      <p className="text-[12px] text-[var(--puvio-text-2)] mt-3 leading-relaxed">{d.note}</p>
    </div>
  );
}
